import React, {useEffect, useRef} from 'react';
import Hls from "hls.js";

function Video({
                   video,
                   aspectRatio,
                   onClick,
               }) {
    const videoRef = useRef();

    useEffect(() => {
        if (!video.playHls) {
            videoRef.current.src = video.shareUrl;
            return;
        }

        if (Hls.isSupported()) {
            var hls = new Hls({
                xhrSetup: function (xhr, url) {
                    xhr.withCredentials = true;
                }
            });

            hls.loadSource(video.url);
            hls.attachMedia(videoRef.current);
        } else if (videoRef.current.canPlayType('application/vnd.apple.mpegurl')) {
            // Safari/iOS kan native HLS
            videoRef.current.src = video.url;
        } else {
            videoRef.current.src = video.shareUrl;
        }
    }, [video])
    return (
        <button type="button" onClick={onClick}>
            <div style={{
                borderRadius: 20,
                position: 'relative',
                aspectRatio,
            }}>
                <video autoPlay={false} muted={true} ref={videoRef}
                       className="flex object-cover w-full"
                       style={{
                           borderRadius: 20,
                           aspectRatio: aspectRatio,
                           zIndex: 2,
                           position: 'absolute',
                           inset: 0,
                       }}>
                    <source src={video.url} type="application/x-mpegURL" />
                </video>
                {video.duration_formatted && <div
                    className={'z-10 font-bold drop-shadow-2xl absolute left-[15px] bottom-[10px] text-white-foreground'}>{video.duration_formatted}</div>}
            </div>
        </button>
    )
}

export default Video;
